export default __webpack_public_path__ + "static/media/hannah_riga.0252de05.png";